export default "__VITE_ASSET__Dx_RY3Vh__"